import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { GetItemMasterMainStore } from "../services/ItemManagementService";
import ItemMasterFilters from "./ItemMasterFilters";
import ItemMasterSearchResults from "./ItemMasterSearchResults";

// Item Master top tab (Delphi IMD0046). Reuses the (IM-scoped) GetItemMasterMain endpoint for the master
// item grid, and the OM item-detail endpoints for the reused sub-tabs.
function ItemMasterTab(props) {
  const accessToken = props.oidc?.user?.access_token;
  const currentUser = props.oidc?.user;
  const dynamicFormSetting = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const [dataSource, setDataSource] = useState(null);

  const searchData = (formFields) => {
    setDataSource(GetItemMasterMainStore(accessToken, formFields || {}));
  };

  // Load once on mount (empty filter = all items).
  useEffect(() => {
    setDataSource(GetItemMasterMainStore(accessToken, {}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  return (
    <div>
      <ItemMasterFilters currentUser={currentUser} DYNAMICFORMSETTING={dynamicFormSetting} searchData={searchData} />
      <ItemMasterSearchResults data={dataSource} accessToken={accessToken} />
    </div>
  );
}

function mapStateToProps(state) { return { oidc: state.oidc }; }
export default connect(mapStateToProps)(ItemMasterTab);
